import React from 'react';
import { useSelector } from 'react-redux';
import { isLoaded } from 'react-redux-firebase';
import { Logo } from '../static';

const AuthIsLoaded = ({ children }) => {  
	const auth = useSelector((state) => state.firebase.auth); 
	  
	if(!isLoaded(auth))
		return (
			<div className="auth-loaded">
				<div className="auth-loaded__logo">
					<Logo />
				</div>
			</div>
		);   
	return children; 
};

export default AuthIsLoaded;
